// extracted by mini-css-extract-plugin
module.exports = {"keyboard":"Nat","line":"Nav","num":"Nax","placeholder":"Naz","key":"Na1","backspace":"Na3","key__img":"Na5","half":"Na7","control":"Na9","featured":"Na-","activated":"Nbb"};